// Preloader.js

import React, { useState, useEffect, useRef } from 'react';
import './Preloader.css'; // Import CSS styles for the preloader
import companyLogo from './../../Assets/logo/RSS logo.webp'; // Import the company logo image
import heroImage from '../../Assets/heroSectionimages/RSS_Security_Team.webp';
import { preloadImages } from '../../utils/preloadImages';

const SAFETY_TIMEOUT_MS = 8000;

const Preloader = ({ onLoaded }) => {
  const [loadingProgress, setLoadingProgress] = useState(0);
  const doneRef = useRef(false);

  useEffect(() => {
    const criticalSrcs = [companyLogo, heroImage];
    const total = criticalSrcs.length;
    let loaded = 0;

    const finish = () => {
      if (doneRef.current) return;
      doneRef.current = true;
      setLoadingProgress(100);
      onLoaded();
    };

    const fontsReady = document.fonts ? document.fonts.ready : Promise.resolve();

    Promise.all([
      preloadImages(criticalSrcs, () => {
        loaded += 1;
        setLoadingProgress(Math.round((loaded / total) * 100));
      }),
      fontsReady,
    ]).then(finish);

    const safetyTimer = setTimeout(finish, SAFETY_TIMEOUT_MS);

    return () => clearTimeout(safetyTimer);
  }, [onLoaded]);

  return (
    <div className="preloader-container">
      <div className="logo">
        <img src={companyLogo} alt="Company Logo" />
      </div>
      <div className="loading-bar">
        <div className="progress" style={{ width: `${loadingProgress}%` }}></div>
      </div>
    </div>
  );
};

export default Preloader;
